import { DeviceEventEmitter, Image, Keyboard, KeyboardAvoidingView, Platform, Pressable, ScrollView, useWindowDimensions, View } from 'react-native'
import React, { useEffect, useRef, useState } from 'react'
import { ThemeConsumer } from '@rneui/themed'
import { config } from '../../../shared/environment'

import { appFonts, fontSize } from 'zen-core-elements/src/shared/constants'
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { CategoryProps } from '../categoryModule'
import { getOnePostDuplicateCheck } from '../../../redux/slices/categorySlice'

import { ZenCheckBox, ZenDropdown, ZenIcon, ZenInput, ZenText } from 'zen-core-elements'
import { ZenRBSheetRef } from 'zen-core-elements/src/elements/zenRBSheet/RBSheet'
import CommonImageUpload, { commonPickerRes } from '../../../shared/commonComponents/commonImageUpload'
import { appColors } from '../../../themes/appTheme'
import { shallowEqual } from 'react-redux'

const Category = ({ formik, isView, parentCategory }: CategoryProps) => {
    const dispatch = useAppDispatch()
    const [open, setOpen] = useState(false)
    const [checkDuplicate, setCheckDuplicate] = useState('')
    const { isWrite: isCategoryWrite } = useAppSelector(getScreenPermission("CategoryStack"), shallowEqual)
    const [dupError, SetDupError] = useState(false)
    const bottomRef = useRef<ZenRBSheetRef>(null)
    useEffect(() => {
        const duplicateDebounceFunction = setTimeout(() => {
            if (checkDuplicate != '') {
                let duplicate = checkDuplicate != '' && checkDuplicate.trim()
                checkDuplicateCategory(String(duplicate));
            }
        }, 500);
        return () => clearTimeout(duplicateDebounceFunction);
    }, [checkDuplicate]);

    const getResolvedImageUri = (imgKey?: string) => {
        if (!imgKey) return '';
        if (imgKey.startsWith('http://') || imgKey.startsWith('https://') || imgKey.startsWith('file://') || imgKey.startsWith('content://')) {
            return imgKey;
        }
        return config.AWSImageUrl + imgKey;
    };

    const checkDuplicateCategory = async (name: string) => {
        if (name != '') {
            let data = {
                value: name,
                columnName: 'categoryName',
                tableName: 'categories',
                storeId: true,
                id: 0
            }
            await dispatch(getOnePostDuplicateCheck({ storeId: config.storeId, data: data })).unwrap().then((response) => {
                if (response) {
                    if (formik?.values?.categoryId < 0) {
                        SetDupError(response?.result?.alreadyExists)
                        DeviceEventEmitter.emit("Duplicate", response?.result?.alreadyExists)
                    }
                }
            })
                .catch((err: any) => {
                    console.log("Error in the getOnePostDuplicateCheck", err);
                })
        }
    }
    //Function used to handle the image picker actions
    const handleImage = (name: string, res?: commonPickerRes[]) => {
        switch (name) {
            case 'Camera':
            case 'Library':
                if (res && res.length > 0) {
                    formik?.setFieldValue('mainImage', res?.[0]?.key || "")
                }
                break;
            case 'StoreImageGallery':
                if (res && res.length > 0) {
                    formik?.setFieldValue('mainImage', res?.[0]?.key || "")
                }
                break;
            case 'Cancel':
                break;
        }
    }

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : undefined} onStartShouldSetResponder={() => { Keyboard?.dismiss(); return false }} enabled style={theme?.addEditCustomerStyle?.outerContainer} >
                    <ScrollView showsVerticalScrollIndicator={false} style={{ backgroundColor: theme?.light, flex: 1, margin: 10, marginBottom: 10, borderRadius: 5 }} contentContainerStyle={{ padding: 10 }} >
                        <View style={{ flexDirection: 'row', alignItems: "center", gap: 15 }}>
                            <View style={{ flex: 1 }}>
                                <ZenInput
                                    label={"Category*"}
                                    labelStyle={{ fontSize: fontSize.smallFontSize, color: appColors.grey, fontFamily: appFonts.medium }}
                                    onBlur={formik.handleBlur('categoryName')}
                                    value={formik.values.categoryName}
                                    onChangeText={(val: string) => {
                                        formik.handleChange('categoryName')(val);
                                        setCheckDuplicate(val.trim() != '' ? val : '')
                                    }}
                                    disabled={isView}
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    inputStyle={{ fontSize: fontSize.mediumFontSize, color: appColors.lightDark }}
                                    errorMessage={formik.touched.categoryName && formik.errors.categoryName ? formik.errors.categoryName : dupError ? "Category Name alreday exist" : undefined}
                                    errorStyle={{ marginBottom: 5, color: 'red', fontSize: fontSize.errorFontSize }}
                                    type='outlined'
                                />
                                <ZenDropdown
                                    items={parentCategory}
                                    title='Parent Category'
                                    open={open}
                                    setOpen={setOpen}
                                    value={formik.values.parentCategory}
                                    setValue={() => { }}
                                    dropdownDirection='BOTTOM'
                                    disabled={isView}
                                    multiple={false}
                                    searchable={true}
                                    placeholder="Select Parent Category"
                                    titleStyle={{ fontSize: fontSize.smallFontSize, color: appColors.grey, fontFamily: appFonts.medium }}
                                    labelStyle={{ fontSize: fontSize.smallerFontSize, color: isView ? appColors.grey : appColors.lightDark, fontFamily: appFonts.medium, }}
                                    placeholderStyle={{ color: appColors.grey, fontSize: fontSize.smallFontSize, }}
                                    style={{ height: 50 }}
                                    containerStyle={{ marginBottom: 10 }}
                                    dropDownContainerStyle={{ borderColor: '#D9D9D9', borderWidth: 1, borderRadius: 6, position: "relative", top: 0, marginBottom: 10, }}
                                    onPress={() => { }}
                                    onSelectItem={(val) => {
                                        formik.setFieldValue('parentCategory', val?.value)
                                        setOpen(false)
                                    }}
                                />
                            </View>
                            <View style={{
                                justifyContent: "flex-end", flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                                marginVertical: 10,
                            }}>
                                {!formik.values.mainImage && isCategoryWrite ? (
                                    /* Upload Choose Image Box */
                                    <Pressable
                                        style={{
                                            width: 150,
                                            height: 150,
                                            borderRadius: 16,
                                            borderWidth: 1.5,
                                            borderStyle: 'dashed',
                                            borderColor: appColors.coolGray,
                                            backgroundColor: '#F8FAFC',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            gap: 8
                                        }}
                                        onPress={() => {
                                            bottomRef?.current?.open();
                                        }}
                                    >
                                        <View style={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: 24,
                                            backgroundColor: 'rgba(0, 83, 116, 0.08)',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <ZenIcon name="camera-outline" type="material-community" size={24} color={appColors.primary} />
                                        </View>
                                        <ZenText content="Choose Image" style={{ fontFamily: appFonts.bold, fontSize: fontSize.smallFontSize, color: appColors.primary }} />
                                    </Pressable>
                                ) : (
                                    /* Single Selected Image Preview Box */
                                    formik?.values?.mainImage ? <View style={{ position: 'relative', width: 150, height: 150 }}>
                                        <View style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: 16,
                                            borderWidth: 1,
                                            borderColor: appColors.coolGray,
                                            overflow: 'hidden',
                                            backgroundColor: appColors.light,
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <Image
                                                style={{ width: '100%', height: '100%' }}
                                                resizeMode='cover'
                                                source={{ uri: getResolvedImageUri(formik.values.mainImage) }}
                                            />

                                            <View style={{ position: 'absolute', bottom: 8, left: 8, zIndex: 10 }}>
                                                <ZenIcon name="cloud-check" type="material-community" size={20} color={appColors.primary} />
                                            </View>
                                        </View>

                                        {/* Modern overlay delete button */}
                                        <Pressable
                                            style={{
                                                position: 'absolute',
                                                top: -6,
                                                right: -6,
                                                zIndex: 10,
                                                backgroundColor: appColors.light,
                                                width: 28,
                                                height: 28,
                                                borderRadius: 14,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                shadowColor: '#000',
                                                shadowOffset: { width: 0, height: 2 },
                                                shadowOpacity: 0.15,
                                                shadowRadius: 4,
                                                elevation: 4,
                                                borderWidth: 1,
                                                borderColor: '#F1F5F9'
                                            }}
                                            onPress={() => {
                                                formik.setFieldValue('mainImage', null);
                                            }}
                                        >
                                            <ZenIcon
                                                type='material-community'
                                                name='close'
                                                color={appColors.red}
                                                size={16}
                                            />
                                        </Pressable>
                                    </View> : undefined
                                )}
                            </View>
                        </View>
                        <ZenCheckBox
                            title='Show in POS Screen'
                            titleStyle={{ fontSize: fontSize.badgeFontSize, color: appColors?.primary, fontFamily: appFonts.bold, }}
                            checked={formik?.values?.isPos}
                            size={22}
                            disabled={isView}
                            checkedColor={appColors.primary}
                            onPress={() => { formik?.setFieldValue('isPos', !formik?.values?.isPos) }}
                        />

                    </ScrollView>
                    <CommonImageUpload
                        bottomRef={bottomRef}
                        propFn={handleImage}
                        gallery={{ isStoreGallery: true, sectionName: "categories", screenName: "categories", }}
                        selectedIndex={{ value: { imagesMaxLength: 1 } }}
                    />
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>
    )
}

export default Category
